// extracted by mini-css-extract-plugin
export default {"chatWindow":"ChatBot_chatWindow__Y-Ru6","slideIn":"ChatBot_slideIn__IgkKp","custom-scrollbar":"ChatBot_custom-scrollbar__a+UAS"};